var _rect, _circle, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcessVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 750,
    viewBox: "0 0 36 750",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    width: 1,
    height: 746,
    fill: "#FFE0DC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 10,
    r: 10,
    fill: "#FFA297"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 195,
    r: 18,
    fill: "#FFA297"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 195,
    r: 10,
    fill: "#FF6452"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 380,
    r: 10,
    fill: "#FFA297"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 565,
    r: 10,
    fill: "#FFA297"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessVertical);
export default __webpack_public_path__ + "static/media/process-vertical.356ba33f6ec7ad7f55da422fca5a7302.svg";
export { ForwardRef as ReactComponent };